<template>
  <button
    type='button'
    class='shop-about-view__requisites-copy'
    :class='{ "is-copied": copied }'
    :aria-label='label'
    :disabled='copied'
    @click='onCopy'
  >
    <span class='si si-clipboard' aria-hidden='true' />
    <span class='shop-about-view__requisites-copy-label'>{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, ref } from 'vue';
import { copyTextToClipboard } from '@helpers/clipboard';

defineOptions({ name: 'RequisitesCopyButton' });

const IDLE_LABEL = 'Скопировать';
const DONE_LABEL = 'Скопировано';
const RESET_MS = 2000;

const props = withDefaults(defineProps<{
  text?: string;
}>(), {
  text: ''
});

const copied = ref(false);
let resetTimer = 0;

const label = computed(() => (copied.value ? DONE_LABEL : IDLE_LABEL));

async function onCopy() {
  if (copied.value || !props.text) return;

  try {
    await copyTextToClipboard(props.text);
  } catch {
    return;
  }

  copied.value = true;
  window.clearTimeout(resetTimer);
  resetTimer = window.setTimeout(() => {
    copied.value = false;
  }, RESET_MS);
}

onBeforeUnmount(() => {
  window.clearTimeout(resetTimer);
});
</script>
